import { Component } from "react";
import type { ReactNode } from "react";

/* UI-DESIGN: a failed scene chunk must never take the readable page down
   with it. Only the decorative scene sits inside this boundary. */
class SceneBoundary extends Component<
  { onUnavailable: () => void; children: ReactNode },
  { failed: boolean }
> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch() {
    this.props.onUnavailable();
  }

  render() {
    return this.state.failed ? null : this.props.children;
  }
}

export default SceneBoundary;
